"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserDevice = exports.getDeviceType = void 0;
const platform_1 = __importDefault(require("platform"));
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const common_1 = require("../common");
const ManufacturerMap = {
    firefox: "mozilla",
    edge: "microsoft",
    chrome: "google",
    safari: "apple",
    unknown: "unknown",
};
function getDeviceType() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/iphone|ipod|android|blackberry|windows phone|iemobile|wpdesktop/.test(userAgent) &&
        !/crkey/.test(userAgent)) {
        return "mobile";
    }
    if (/ipad/.test(userAgent) || "ontouchstart" in document.documentElement) {
        return "tablet";
    }
    return "desktop";
}
exports.getDeviceType = getDeviceType;
function getBrowserDevice() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const browser = (0, common_1.getBrowser)();
        const browserVersion = (0, common_1.getBrowserVersion)();
        const type = getDeviceType();
        return {
            id: (0, js_player_shared_1.getDeviceId)(),
            type,
            name: `${(0, common_1.getOS)()} ${browser} ${browserVersion}`,
            manufacturer: ManufacturerMap[browser],
            model: `${type}-browser-${browser}-${browserVersion}`,
            os: (_b = (_a = platform_1.default.os) === null || _a === void 0 ? void 0 : _a.family) !== null && _b !== void 0 ? _b : "unknown",
            osVersion: (_d = (_c = platform_1.default.os) === null || _c === void 0 ? void 0 : _c.version) !== null && _d !== void 0 ? _d : "unknown",
        };
    });
}
exports.getBrowserDevice = getBrowserDevice;
//# sourceMappingURL=browser.js.map